export default {
	appName: 'GinRummy',
	version: '1.4.1',
	fullVersion: false,
	showErrors: false,
	showAppLinks: false,
	debugMode: false,
	facebookAdId: 158327870889130,
	showMoreGames: true,
	showAbout: true,
	showIAPPage: false,
	ShowRateGame: false,
	TestMode: false,
	maxPingAllowed: 500,
	autoTestMode: false,
	removeAds: true,
	GAProperty: 'UA-43146845-1',
	ios: '6470861992',
	android: 'com.jdsoftwarellc.ginrummy',
	windows: '',
	email: 'gin@jdsoftwarellc.com',
	emailSubject: 'Feedback',
	shareUrl: 'https://cardsjd.com/ginrummy/',
	shareTitle: 'Gin Rummy',
	shareText: "Let's play Gin Rummy",
	gamesUrl: 'https://cardsjd.com/config/moregames.json',
	colyseusServer: 'wss://ginserver.jimmyinteractive.com', //'ws://localhost:8080', //'ws://localhost:2567', //
};
